import type { ReactNode } from 'react';

export const symbol_install_desktop: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M330-150v-50H140q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h330q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v520h680v-110q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v110q0 24-18 42t-42 18H630v50q0 12.75-8.62 21.37Q612.75-120 600-120H360q-12.75 0-21.37-8.63Q330-137.25 330-150Zm320-378v-282q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v282l93-93q9-9 21-9t21 9q9 9 9 21t-9 21L701-435q-9 9-21 9t-21-9L515-579q-9-9-9-21t9-21q9-9 21-9t21 9l93 93Z"
		/>
	</svg>
);
